import _ from 'underscore';

/////////////////////////////////////////////////////////////////////////
// SpritePool //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const SpritePool = {
  
  init: function(game, poolSize, spriteClass) {

    this.game = game;
    this.pool = new Array(poolSize);
    this.index = poolSize;
    this.spriteClass = spriteClass;
    this.classArgs = Array.prototype.slice.call(arguments, 3);

    for (var i = 0; i < poolSize; i++) {
      this.pool[i] = this.createObject(i);
    }

    return this;
  },
        
  createObject: function(idx) {

    var name = this.spriteClass.namePrefix;    
    var inst = new this.spriteClass(this.game, this.classArgs[0]);
    if (_.isFunction(inst.init))
    {
      inst.init();
    }
    inst.name = name+idx;
    inst.pool = this;
    inst.exists = false;
    inst.events.onKilled.add(this._onSpriteKilled, this);

    return inst;

  },

  getObject: function() {
      
    if (this.index === 0)
    {
      // grow the array
      this._growPool();
    }
    
    var newObject = this.pool[--this.index];
    if (_.has(newObject, 'animations') && newObject.animations.length > 0) {
      newObject.animations.getAnimation('run').frame = 0;  
    }
    
    newObject.revive();

    if (_.isFunction(newObject.reset))
    {
      newObject.reset();
    }

    return newObject;
  },
    
  returnObject: function(obj) {

    // N/a, use sprite.kill()
  
  },

  isMaxedOut: function() {

    return (this.index === this.pool.length);
    
  },

  _growPool: function() {
      
    //Logger.warn('grow pool ');
    this.pool.unshift(this.createObject('ex'));
    this.index = 1;


  },

  _onSpriteKilled: function(sprite) {

    // remove from parent
    // Is this what causes problems with physics engine when re-using object?
    if (sprite.parent) 
    {
      if (sprite.parent.hasOwnProperty('remove')) 
      {
        sprite.parent.remove(sprite);  
      }
      else 
      {
        sprite.parent.removeChild(sprite);
      }
      
    }

    // update pool index - use the returned sprite first on next call
    // to getObject()
    this.pool[this.index++] = sprite;

  }



};

export default SpritePool;




// WEBPACK FOOTER //
// ./app/src/utils/display/SpritePool.js